import { Button, Stack } from '@mui/material';
import { FC } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { IParams, Page } from '../../../shared';
import { DeleteSupportCaseAction, DuplicatesWarning, SupportCaseTitle } from '../../components';
import { useGetSupportCase } from '../../hooks';
import { FoodRestrictions } from '../../components/food-restrictions/food-restrictions.component';
import { Supportees } from '../../components/supportees/supportees.component';
import { Residence } from '../../components/residence/residence.component';
import { Contacts } from '../../components/contacts/contacts.component';
import { useTranslation } from 'react-i18next';

export const SupportCaseDetailsPage: FC = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { id } = useParams<keyof IParams>() as IParams;
    const { data: supportCase } = useGetSupportCase(id);

    return (
        <Page
            onBack={() => navigate(-1)}
            title={<SupportCaseTitle supportCase={supportCase} />}
            actions={
                <Stack spacing={2} direction="row">
                    <DeleteSupportCaseAction supportCase={supportCase} />
                    <Button
                        variant="contained"
                        onClick={() => navigate(`/registration/info?case=${supportCase?.id}`)}
                        children={t('startRegistration')}
                    />
                </Stack>
            }
        >
            {supportCase && (
                <Stack spacing={2}>
                    <DuplicatesWarning supportCaseId={id} />
                    <Supportees supportCase={supportCase} />
                    <Residence supportCase={supportCase} />
                    <Contacts supportCase={supportCase} />
                    <FoodRestrictions supportCase={supportCase} />
                </Stack>
            )}
        </Page>
    );
};
